import { InteractionsLogger } from './interactionsLogger';
import { InteractionsLoggerV1 } from './interactionsLoggerV1';
import { InteractionsLoggerV2 } from './interactionsLoggerV2';
import {
    PlaceEventInteraction,
    PLACE_EVENT_INTERACTION,
} from './placeEventInteraction';

export class EventsInteractionsTracker {
    private LOG_PERIODICITY_MILLISECONS = 5000;
    private interactionsLoggers: InteractionsLogger[];
    private interactions: Array<PlaceEventInteraction> = [];
    private element: Subscribable;
    private setInterval: (callback: () => void, milliseconds: number) => void;

    constructor(
        element: Subscribable,
        interactionsLoggers = [
            new InteractionsLoggerV1(),
            new InteractionsLoggerV2(),
        ],
        setInterval = window.setInterval,
    ) {
        this.element = element;
        this.interactionsLoggers = interactionsLoggers;
        this.setInterval = setInterval;
    }

    listen() {
        this.element.addEventListener(PLACE_EVENT_INTERACTION, (event) => {
            this.interactions.push(event.detail);
        });
    }

    track() {
        this.setInterval.call(
            window,
            () => {
                this.logStoredInteractions();
            },
            this.LOG_PERIODICITY_MILLISECONS,
        );

        this.element.addEventListener('beforeunload', () =>
            this.logStoredInteractions(),
        );
    }

    private logStoredInteractions() {
        const logsLimit = 10;
        for (let i = 0; i < this.interactions.length; i += logsLimit) {
            const logsBlock = this.interactions.slice(i, i + logsLimit);
            this.interactionsLoggers.forEach((il) => {
                il.log(logsBlock);
            });
        }
        this.interactions = [];
    }
}

export interface Subscribable {
    addEventListener(
        type: string,
        listener: (event: { detail: PlaceEventInteraction }) => void,
    ): void;
}
